import React, { Component } from "react";

import "./Book.css";

class Book extends Component {
  render() {
    const book = this.props.book;

    return (
      <div className="Book">
        <img className="BookThumbnail" alt={book.title} src={book.thumbnail} />
        <div className="BookInfo">
          <div className="BookTitle">{book.title}</div>
          <div className="BookAuthor">{book.author}</div>
        </div>
      </div>
    );
  }
}

export default Book;
